import { ModelBase } from './model';

class UserCardResponse extends ModelBase {
  static namespace = 'user_card_response';
}
export default UserCardResponse.register();
